/**
 * @file
 * Behaviors for the Tools.
 */

!((Drupal, $) => {
  'use strict';

  /**
   * Setup and attach the Tools behaviors.
   *
   * @type {Drupal~behavior}
   */
  Drupal.behaviors.tools = {
    attach: function() {
      $('.tool-page .field--name-field-additional-links .field__item a').before(
        '<div class="category">Link</div>'
      );
    }
  };
})(Drupal, jQuery);
